export default __webpack_public_path__ + "static/media/search.089c1141.svg";